export const SET_DRAFT_SCHEDULE = 'SET_DRAFT_SCHEDULE';
export const RESET_DRAFT_SCHEDULE = 'RESET_DRAFT_SCHEDULE';
export const SET_FIRM_SCHEDULE = 'SET_FIRM_SCHEDULE';
export const RESET_FIRM_SCHEDULE = 'RESET_FIRM_SCHEDULE';

export const FETCH_WORKFLOWS = 'FETCH WORKFLOWS'
